import React from 'react';
import {
  Container,
  Grid,
  Header,
  Image,
  Button,
  Icon,
} from 'semantic-ui-react';

import { flattenToAppURL } from '@plone/volto/helpers';
import { getImageUrl } from '../../../utils/images';

type LayoutVariant = 'variant1' | 'variant2';

interface ActionLink {
  '@id': string;
}

interface ActionItem {
  label?: string;
  variant?: string;
  link?: ActionLink[];
}

interface CallToActionData {
  backgroundImage?: string | null;
  layout?: LayoutVariant;
  title?: string;
  text?: string;
  actions?: ActionItem[];
}

interface CallToActionViewProps {
  data?: CallToActionData;
}

const CallToActionView = ({ data = {} }: CallToActionViewProps) => {
  const {
    backgroundImage = null,
    layout = 'variant1',
    title = 'TRY CASTLE CMS',
    text = 'Request a demo and see how it can benefit your organization.',
    actions = [],
  } = data;

  const imageUrl = getImageUrl(backgroundImage);

  if (layout === 'variant1') {
    return (
      <section className="cta-block fullbleed">
        <Container>
          <Grid stackable verticalAlign="middle" columns={2}>
            <Grid.Row>
              <Grid.Column width={6}>
                {imageUrl && (
                  <Image src={imageUrl} fluid className="cta-image" />
                )}
              </Grid.Column>
              <Grid.Column width={6}>
                <Header as="h2" className="cta-title">
                  {title}
                </Header>
                <p className="cta-text">{text}</p>
                <div className="cta-actions">
                  {actions.slice(0, 2).map((action, idx) => (
                    <Button
                      key={idx}
                      as="a"
                      href={flattenToAppURL(action.link?.[0]?.['@id'] || '')}
                      className={`cta-btn ${action.variant || 'primary'}`}
                      circular
                    >
                      {action.label}
                      <Icon name="arrow right" />
                    </Button>
                  ))}
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </section>
    );
  }

  if (layout === 'variant2') {
    return (
      <section
        className="cta-alt-block fullbleed"
        aria-label="Call to action"
      >
        <Container textAlign="center">
          <Header as="h2" className="cta-alt-title">
            {title}
          </Header>
          <p className="cta-alt-subtitle">{text}</p>
          <div className="cta-alt-actions">
            {actions.slice(0, 2).map((action, idx) => (
              <Button
                key={idx}
                as="a"
                href={flattenToAppURL(action.link?.[0]?.['@id'] || '')}
                className={`cta-alt-btn ${action.variant || 'primary'}`}
                circular
              >
                {action.label}
                <Icon name="arrow right" />
              </Button>
            ))}
          </div>
        </Container>
      </section>
    );
  }

  return null;
};

export default CallToActionView;